import { Suspense } from 'react';
import { Route, createBrowserRouter, RouterProvider, createRoutesFromElements } from 'react-router-dom';
import { ORConsolePage } from '../pages/or-console';
import { MissionControlHome } from '../pages/mission-control-home';
import { UserProvider } from '@vitvio/user-context';
import { DemoFunctionalityProvider } from '@vitvio/demo-functionality';
import { ORGANIZATION_MANAGEMENT_HOME, OR_CONSOLE_ROUTE } from '@vitvio/navigation';
import { MissionControlCalendarProvider } from '@vitvio/mission-control';
import { DEMO_OVERRIDE } from '../config';
import { OrganizationManagementPage } from '../pages/organization-management-page';
import { TimeProvider } from '@vitvio/time-components';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { MISSION_CONTROL_ONLY_FLAG } from '@vitvio/feature-flags';
import { WholeScreenLoader, NoConnectionPage } from '@vitvio/shared-components';
import { InitialConnectionGuard } from '@vitvio/connection-provider';
import { PageNotFound } from '../pages/404-page-not-found';

export function AuthenticatedApp() {
  const { getFlag } = useKindeAuth();
  const missionControlOnly = (getFlag && getFlag(MISSION_CONTROL_ONLY_FLAG, false, 'b').value) || false;

  const router = createBrowserRouter(createRoutesFromElements(<Route>{getRoutes(missionControlOnly)}</Route>));

  return (
    <Suspense fallback={<WholeScreenLoader />}>
      <UserProvider loaderComponent={<WholeScreenLoader />}>
        <DemoFunctionalityProvider demoOverride={DEMO_OVERRIDE}>
          <TimeProvider>
            <MissionControlCalendarProvider>
              <RouterProvider router={router} />
            </MissionControlCalendarProvider>
          </TimeProvider>
        </DemoFunctionalityProvider>
      </UserProvider>
    </Suspense>
  );
}

function getRoutes(missionControlOnly: boolean) {
  if (missionControlOnly) {
    return (
      <>
        <Route path="/no-connection" element={<NoConnectionPage />} />
        <Route element={<InitialConnectionGuard />}>
          <Route index element={<MissionControlHome />} />
        </Route>
      </>
    );
  }

  return (
    <>
      <Route path="/no-connection" element={<NoConnectionPage />} />
      <Route element={<InitialConnectionGuard />}>
        <Route index element={<MissionControlHome />} />
        <Route path={OR_CONSOLE_ROUTE} element={<ORConsolePage />} />
        <Route path={ORGANIZATION_MANAGEMENT_HOME} element={<OrganizationManagementPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </>
  );
}
